import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

//fetch prescriptions for a patient
export const fetchPrescriptions = createAsyncThunk(
    'prescriptions/fetchPrescriptions',
    async (patientId, thunkAPI) => {
        try{
            const res = await fetch(`/api/v1/patients/${patientId}/prescriptions`);
            if(!res.ok) throw new Error("Failed to fetch prescriptions");
            const data = await res.json();
            return data.sort((a,b) => new Date(b.created_at) - new Date(a.created_at));
                       
        } catch (err){
            return thunkAPI.rejectWithValue(err.message);
        }
    }
);

export const submitPrescriptions = createAsyncThunk(
  'prescriptions/submitPrescription',
  async ({ payload, editingId }, thunkAPI) => {
    try {
      const method = editingId ? 'PATCH' : 'POST';
      const url = editingId
        ? `/api/v1/prescriptions/${editingId}`
        : `/api/v1/prescriptions`;

      // Include the id if it's an update
      const updatedPayload = editingId
        ? { ...payload, id: editingId }
        : payload;

      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prescription: updatedPayload }),
      });

      if (!res.ok) throw new Error("Failed to submit prescription");

      const updated = await res.json();
      return { updated, editingId };
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);



const initialState = {
    // prescriptions: [],
    prescriptionsByPatient: {},
    loading: false,
    submitting: false,
    error: null
}

const prescriptionSlice = createSlice({
    name: 'prescriptions',
    initialState,
    reducers: {
 
        clearPrescriptions(state, action){
            const patientId = action.payload;
            if(patientId){
                delete state.prescriptionsByPatient[patientId];
            } else {
                state.prescriptionsByPatient = {};
            }
            state.error = null;
        }

    },
    extraReducers: (builder) => {
        builder
        .addCase(fetchPrescriptions.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchPrescriptions.fulfilled, (state,action) => {
            state.loading = false;
            state.prescriptionsByPatient[action.meta.arg] = action.payload;
        })
        .addCase(fetchPrescriptions.rejected, (state,action) => {
            state.loading = false;
            state.error = action.payload;
        })
        .addCase(submitPrescriptions.pending, (state) => {
            state.submitting = true;
            state.error = null;
        })
        .addCase(submitPrescriptions.fulfilled, (state, action) => {
            const { updated, editingId } = action.payload;
            const patientId = updated.patient_id;

            if(!state.prescriptionsByPatient[patientId]){
                state.prescriptionsByPatient[patientId] = [];
            }

            if(editingId){
                state.prescriptionsByPatient[patientId] = state.prescriptionsByPatient[patientId].map(p =>
                    p.id === updated.id ? updated : p
                );
            } else {
                state.prescriptionsByPatient[patientId].unshift(updated);
            }

            state.submitting = false;
        })
        .addCase(submitPrescriptions.rejected, (state, action) => {
            state.submitting = false;
            state.error = action.payload;
        })
    },
});

export const { clearPrescriptions } = prescriptionSlice.actions;
export const selectPrescriptions = (patientId) => (state) =>
  state.prescriptions.prescriptionsByPatient[patientId] || [];
export const selectPrescriptionsLoading = (state) => state.prescriptions.loading;
export const selectPrescriptionsSubmitting = (state) => state.prescriptions.submitting;
export const selectPrescriptionsError = (state) => state.prescriptions.error;


export default prescriptionSlice.reducer;